export default {
    loading: false,

    orders: null,
    buttons: {
        agreements: null,
        departureTourists: null,
        tourTourists: null,
    },
    chart: {
        data: {
            labels: [],
            datasets: [
                {

                    data: [],
                    backgroundColor: [],
                }
            ],
        },
        options: {
            segmentStrokeWidth: 2,
            cutoutPercentage: 75,
            legend: {
                display: false,
            }
        },
        AgreementsInStatuses: null,
        TotalCount: null,
    },
    events: {
        today: [],
        tomorrow: [],
    },
}